import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import {LabPartners} from './LabPartners';
import {VariantType, OnChangeType} from './LabPartnersTypes';

const createOption = ([key, value]: [string, string]) => (
    <MenuItem key={key} value={key}>
        {String(value).toUpperCase()}
    </MenuItem>
);

export const getInputLabel = (variant: string, placeholder = 'LAB PARTNERS') => {
    if (variant === 'outlined') return null;

    return <InputLabel id="lab-partners-label">{placeholder}</InputLabel>;
};

interface Props {
    onChange: OnChangeType;
    value: string;
    variant?: VariantType;
    placeholder: string;
    labPartners?: {[key: string]: string};
}

export default function LabPartnersContainer(props: Props) {
    const {onChange, value, variant = 'standard', placeholder, labPartners = {}} = props;
    const opts = Object.entries(labPartners).map(createOption);
    const inputLabel = getInputLabel(variant, placeholder);

    const formStyle = {
        minWidth: 200,
    };

    return (
        <LabPartners
            formStyle={formStyle}
            inputLabel={inputLabel}
            value={value}
            onChange={onChange}
            variant={variant}
            opts={opts}
        />
    );
}
